// extracted by mini-css-extract-plugin
export default {"waveform":"style__waveform____t7NN"};